module.exports = __webpack_public_path__ + "img/exam (2).0b57f1e7.png";